<template>
  <article class="group relative flex w-full">
    <AtomLink :url="entryUrl" class="flex w-full rounded-br-none rounded-lg overflow-hidden md:rounded-xl">
      <MoleculePicture
        :image="image"
        :alt="imgAlt"
        :fallback="true"
        class="v-hover-zoom-image w-full object-cover transform transition duration-200"
        :class="{ 'aspect-4/3': !collageLarge && !collageMedium }"
      />
      <div
        class="absolute z-10 bottom-0 right-0 pl-6 pr-2 pt-2 w-5/6 bg-white rounded-tl-xl"
        :class="{
          'xl:w-1/2 xl:pt-6 xl:pl-8': collageLarge || collageMedium,
        }"
      >
        <div class="border-b-2 border-solid border-app-green">
          <p v-if="entryType" class="text-xs uppercase">{{ entryType }}</p>
          <h3
            class="flex mb-2 font-bold leading-tight"
            :class="{
              'lg:text-lg xl:text-xl': collageLarge,
              'lg:text-base xl:text-lg': collageMedium,
            }"
          >
            <span class="flex-auto">{{ entryTitle }}</span>
            <AtomIconArrowRight class="inline-block shrink-0 self-end mb-1 ml-3 w-3 h-3 text-app-green transform group-hover:translate-x-1 transition duration-200" />
          </h3>
          <div v-if="subtitle" class="mb-2" v-html="truncate(subtitle)" />
        </div>
      </div>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
import { truncate } from '~/composables/util'

interface Props {
  entryType?: string
  entryTitle: string
  subtitle?: string
  entryUrl: string
  image?: object
  imgAlt?: string
  collageLarge?: boolean
  collageMedium?: boolean
}

defineProps<Props>()
</script>
